// One-tap jump to the OS settings page for this app.
// Uses the iOS `app-settings:` URL scheme inside Capacitor's WKWebView, which
// iOS resolves to the app's own Settings page (same destination as
// UIApplication.openSettingsURLString). No custom native plugin needed.
import { isNative } from "./index";
import { toast } from "sonner";

export async function openAppSettings(): Promise<void> {
  if (isNative()) {
    try {
      window.location.href = "app-settings:";
      return;
    } catch (e: any) {
      toast.error(e?.message ?? "Couldn't open Settings.");
      return;
    }
  }
  toast.message("Open your browser's site settings to change permissions.");
}

// Opens the iOS Settings app root (not Roava's per-app page). Uses the
// unofficial `App-Prefs:` URL scheme — works on current iOS versions and is
// widely used, though Apple could change/restrict it in the future.
export async function openIosSettingsRoot(): Promise<void> {
  if (isNative()) {
    try {
      window.location.href = "App-Prefs:";
      return;
    } catch (e: any) {
      toast.error(e?.message ?? "Couldn't open Settings.");
      return;
    }
  }
  toast.message("Open iOS Settings and tap the airplane icon (or use Control Center).");
}

